import GeneralOptionsPanel from "components/optionspanel/GeneralOptionsPanel";
import MyDetails from "personalsettings/mydetailspanel/mydetails";
import React, { useState } from "react";
import DeactivateAccountModal from "./deactivateaccountmodal";
import ResetPasswordModal from "./resetpasswordmodal";

interface Props {
  optionsPanelData: server.dto.OptionsPanelDataV2
  listUrl: string
  userToClient: server.dto.UserForInternalAdmin | server.dto.UserForExternalAdmin
  userSmall: server.dto.UserSmall
}

const UserOptionsPanel = (props: Props) => {
  const [displayPasswordResetModal, setDisplayPasswordResetModal] = useState<boolean>(false);
  const [displayDeactivateUserModal, setDisplayDeactivateUserModal] = useState<boolean>(false);

  const isUserActivated = props.userToClient.lifeCycle === "active";
  const isLoggedinUser = props.userToClient.user.userId === site.currentUser.userId;

  return <>
    <GeneralOptionsPanel
      title={<MyDetails user={props.userSmall} />}
      links={[
        {
          href: props.listUrl,
          text: RESX.Buttons.ListView,
          visible: true
        }, {
          onClick: () => { setDisplayDeactivateUserModal(true); },
          text: RESX.SoUser.DeactivateAccount,
          visible: isUserActivated && !isLoggedinUser,
        }, {
          onClick: () => { setDisplayPasswordResetModal(true); },
          text: RESX.SoUser.ResetPassword,
          visible: isUserActivated && !isLoggedinUser,
        }
      ]}
      data={props.optionsPanelData}
    />

    <ResetPasswordModal
      onClose={() => { setDisplayPasswordResetModal(false); }}
      isOpen={displayPasswordResetModal}
      userId={props.userToClient.user.userId}
    />

    <DeactivateAccountModal
      onClose={() => { setDisplayDeactivateUserModal(false); }}
      isOpen={displayDeactivateUserModal}
      userToClient={props.userToClient}
    />
  </>;
};

export default UserOptionsPanel;